import { Box, Chip, Typography, Dialog, DialogContent } from '@mui/material';
import { InfoField, InfoFieldValue } from '@occc/ui-design-system';

import { ReactNode, useState } from 'react';

type ViewAllProps = {
  label: string;
  count: number;
  description: string;
  value?: string | number | ReactNode;
  disableTypography?: boolean;
  buttonLabel?: string;
  renderContent: (show: (isShown: boolean) => void) => ReactNode;
};

export const ViewAll = ({
  label,
  count,
  description,
  value,
  disableTypography,
  buttonLabel = 'View All',
  renderContent,
}: ViewAllProps) => {
  const [isShown, setIsShown] = useState(false);

  return (
    <>
      <InfoField
        label={label}
        value={
          <>
            {value || value === 0 ? (
              <InfoFieldValue value={value} disableTypography={disableTypography} truncate />
            ) : null}
            <Box display='flex' alignItems='center' flexDirection='row' gap={1}>
              <Typography variant='body1' color='text.primary'>
                {count} {description}
              </Typography>
              <Chip
                label={buttonLabel}
                variant='outlined'
                color='primary'
                onClick={() => setIsShown(true)}
              />
            </Box>
          </>
        }
        disableTypography
      />
      <Dialog open={isShown} onClose={() => setIsShown(false)} maxWidth='md'>
        <DialogContent sx={{ p: 0 }}>{renderContent(setIsShown)}</DialogContent>
      </Dialog>
    </>
  );
};
